

// "use client";
// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Container,
//   Typography,
//   Paper,
//   Chip,
//   Stack,
//   Button,
// } from "@mui/material";
// import dynamic from "next/dynamic";
// import { useRouter } from "next/navigation";
// import { useTranslation } from "react-i18next";
// const Chart = dynamic(() => import("react-apexcharts"), { ssr: false });
// import NextLink from "next/link";
// const GetgeekHiringCircular = () => {
//   const router = useRouter();
//   const { t, i18n } = useTranslation();
//   const isArabic = i18n.language === "ar";

//   const [animatedValues, setAnimatedValues] = useState([0, 0]);
//   const [hasAnimated, setHasAnimated] = useState(false);
//   const [hoveredIndex, setHoveredIndex] = useState(null);

//   const easeOutQuart = (t) => 1 - Math.pow(1 - t, 4);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting && !hasAnimated) {
//             setHasAnimated(true);
//             [94, 90].forEach((target, index) => {
//               const duration = 2000;
//               const startTime = Date.now();
//               const animate = () => {
//                 const elapsed = Date.now() - startTime;
//                 const progress = Math.min(elapsed / duration, 1);
//                 const easedProgress = easeOutQuart(progress);
//                 const current = easedProgress * target;
//                 setAnimatedValues((prev) => {
//                   const newValues = [...prev];
//                   newValues[index] = Math.round(current);
//                   return newValues;
//                 });
//                 if (progress < 1) requestAnimationFrame(animate);
//               };
//               setTimeout(() => animate(), index * 200);
//             });
//           }
//         });
//       },
//       { threshold: 0.3 },
//     );
//     const element = document.getElementById("charts-container");
//     if (element) observer.observe(element);
//     return () => {
//       if (element) observer.unobserve(element);
//     };
//   }, [hasAnimated]);

//   const circularChartOptions = (percentage, color, isHovered) => ({
//     chart: {
//       type: "radialBar",
//       sparkline: { enabled: true },
//       animations: {
//         enabled: true,
//         easing: "easeinout",
//         speed: 1500,
//         animateGradually: { enabled: true, delay: 150 },
//         dynamicAnimation: { enabled: true, speed: 350 },
//       },
//     },
//     plotOptions: {
//       radialBar: {
//         startAngle: -135,
//         endAngle: 225,
//         hollow: { size: "65%" },
//         track: {
//           background: "#f0ebf8",
//           strokeWidth: "100%",
//           opacity: isHovered ? 0.8 : 1,
//         },
//         dataLabels: { name: { show: false }, value: { show: false } },
//       },
//     },
//     fill: { colors: [color] },
//     stroke: { lineCap: "round" },
//   });

//   const metrics = [
//     {
//       percentage: 94,
//       displayPercentage: 94,
//       color: "#775CE5",
//       label: t("getgeekHiringCircular.metrics.metric1"),
//       size: 320,
//       showPercentage: true,
//       numberFontSize: {
//         xs: "28px",
//         sm: "32px",
//         md: "40px",
//         lg: "50px",
//         xl: "60px",
//       },
//     },
//     {
//       percentage: 90,
//       displayValue: "1M+",
//       color: "#775CE5",
//       label: t("getgeekHiringCircular.metrics.metric2"),
//       size: 270,
//       showPercentage: false,
//       numberFontSize: {
//         xs: "26px",
//         sm: "30px",
//         md: "36px",
//         lg: "36px",
//         xl: "44px",
//       },
//     },
//   ];

//   return (
//     <Box
//       sx={{
//         py: { xs: 4, sm: 6, md: 8 },
//         mt: { xs: 2, sm: 2, md: "-7%" },
//         direction: isArabic ? "rtl" : "ltr",
//       }}
//     >
//       <Container maxWidth="lg">
//         <Box
//           sx={{
//             bgcolor: "#FAF6FC",
//             borderRadius: 4,
//             p: { xs: 3, sm: 4, md: 6, lg: 8 },
//           }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: { xs: "column", md: "row" },
//               gap: { xs: 4, sm: 5, md: 6 },
//               alignItems: "flex-start",
//             }}
//           >
//             {/* Left Content */}
//             <Box sx={{ flex: 1, width: "100%" }}>
//               <Chip
//                 label={t("getgeekHiringCircular.chip")}
//                 sx={{
//                   backgroundColor: "transparent",
//                   border: "1px solid #0206174D",
//                   mb: 2,
//                   color: "#818E98",
//                   fontSize: { xs: "12px", sm: "14px", md: "16px", lg: "17px" },
//                   fontWeight: "500",
//                   textTransform: "capitalize",
//                   px: 0.7,
//                   py: { xs: 1.2, sm: 1.5, md: 2, lg: 2.3 },
//                   fontFamily: "var(--font-outfit)",
//                   borderRadius: "40px",
//                 }}
//               />

//               <Typography
//                 variant="h3"
//                 sx={{
//                   fontWeight: 600,
//                   mb: 2.8,
//                   fontSize: {
//                     xs: "1.5rem",
//                     sm: "1.75rem",
//                     md: "2rem",
//                     lg: "2rem",
//                     xl: "2.5rem",
//                   },
//                   lineHeight: 1.3,
//                   fontFamily: "var(--font-plusjakarta)",
//                   color: "#020617",
//                   maxWidth: { xs: "100%", lg: "610px" },
//                   textAlign: isArabic ? "right" : "left",
//                 }}
//               >
//                 {t("getgeekHiringCircular.title1")}
//                 <span style={{ color: "#775CE5" }}>
//                   {t("getgeekHiringCircular.titleHighlight1")}
//                   {/* <br /> */}
//                 </span>
//                 {t("getgeekHiringCircular.title2")}
//                 <span style={{ color: "#775CE5" }}>
//                   {t("getgeekHiringCircular.titleHighlight2")}
//                 </span>
//               </Typography>

//               {/* <Typography
//                 sx={{
//                   color: "#020617",
//                   mb: 2.5,
//                   lineHeight: 1.4,
//                   fontFamily: "var(--font-outfit)",
//                   fontSize: {
//                     xs: "16px",
//                     sm: "16px",
//                     md: "16px",
//                     lg: "16px",
//                     xl: "20px",
//                   },
//                   maxWidth: { xs: "100%", lg: 500 },
//                   textAlign: isArabic ? "right" : "left",
//                 }}
//               >
//                 {t("getgeekHiringCircular.stat1")}
//               </Typography> */}

//               <Typography
//                 variant="body1"
//                 sx={{
//                   color: "#02061799",
//                   mb: 2.5,
//                   lineHeight: 1.3,
//                   fontFamily: "var(--font-outfit)",
//                   fontSize: {
//                     xs: "15px",
//                     sm: "16px",
//                     md: "17px",
//                     lg: "17px",
//                     xl: "19px",
//                   },
//                   maxWidth: { xs: "100%", lg: "550px" },
//                   fontWeight: 400,
//                   textAlign: isArabic ? "right" : "left",
//                 }}
//               >
//                 {t("getgeekHiringCircular.para1")}
//               </Typography>

//               {/* <Typography
//                 variant="body1"
//                 sx={{
//                   color: "#02061799",
//                   mb: { xs: 2.5, md: 5 },
//                   lineHeight: 1.3,
//                   maxWidth: { xs: "100%", lg: "550px" },
//                   fontWeight: 400,
//                   fontSize: {
//                     xs: "15px",
//                     sm: "16px",
//                     md: "17px",
//                     lg: "17px",
//                     xl: "19px",
//                   },
//                   fontFamily: "var(--font-outfit)",
//                   textAlign: isArabic ? "right" : "left",
//                 }}
//               >
//                 {t("getgeekHiringCircular.para2")}
//               </Typography>

//               <Typography
//                 variant="body1"
//                 sx={{
//                   color: "#02061799",
//                   mb: { xs: 3, md: 5 },
//                   lineHeight: 1.3,
//                   maxWidth: { xs: "100%", lg: "550px" },
//                   fontWeight: 400,
//                   fontSize: {
//                     xs: "15px",
//                     sm: "16px",
//                     md: "17px",
//                     lg: "17px",
//                     xl: "19px",
//                   },
//                   fontFamily: "var(--font-outfit)",
//                   textAlign: isArabic ? "right" : "left",
//                 }}
//               >
//                 {t("getgeekHiringCircular.para3")}
//               </Typography> */}

//               {/* Stats Boxes */}
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: 1.5,
//                   maxWidth: { xs: "100%", lg: "550px" },
//                 }}
//               >
//                 {[
//                   {
//                     val: t("getgeekHiringCircular.box1Value"),
//                     label: t("getgeekHiringCircular.box1Label"),
//                   },
//                   {
//                     val: t("getgeekHiringCircular.box2Value"),
//                     label: t("getgeekHiringCircular.box2Label"),
//                   },
//                   {
//                     val: t("getgeekHiringCircular.box3Value"),
//                     label: t("getgeekHiringCircular.box3Label"),
//                   },
//                 ].map((box, i) => (
//                   <Paper
//                     key={i}
//                     elevation={0}
//                     sx={{
//                       bgcolor: "#E8D9FF",
//                       p: { xs: 1.5, sm: 2 },
//                       borderRadius: 3,
//                       transition: "all 0.3s ease",
//                       "&:hover": {
//                         transform: isArabic
//                           ? "translateX(-8px)"
//                           : "translateX(8px)",
//                         boxShadow: "0 4px 20px rgba(119, 92, 229, 0.15)",
//                       },
//                     }}
//                   >
//                     <Typography
//                       variant="h4"
//                       sx={{
//                         color: "#9048FB",
//                         fontWeight: 700,
//                         mb: 0.5,
//                         ml: "2%",
//                         fontFamily: "var(--font-outfit)",
//                         fontSize: { xs: "1.75rem", sm: "2rem", md: "2.125rem" },
//                       }}
//                     >
//                       {box.val}
//                     </Typography>
//                     <Typography
//                       variant="body1"
//                       sx={{
//                         color: "#02061799",
//                         fontFamily: "var(--font-outfit)",
//                         ml: "2%",
//                         fontWeight: 400,
//                         fontSize: { xs: "14px", sm: "15px", md: "16px" },
//                       }}
//                     >
//                       {box.label}
//                     </Typography>
//                   </Paper>
//                 ))}

//                 <Stack
//                   direction={{ xs: "column", sm: "row" }}
//                   spacing={{ xs: 1.5, sm: 2 }}
//                   alignItems={{ xs: "stretch", sm: "center" }}
//                   sx={{ mt: "2%" }}
//                 >
//                   <NextLink href="/free-trial-of-ai-recruiting-tool" passHref legacyBehavior>
//                     <Button
//                       component="a"
//                       sx={{
//                         textTransform: "none",
//                         px: { xs: 2.5, sm: 3, md: 2.8 },
//                         py: { xs: 1.5, sm: 1.6, md: 1.5 },
//                         height: { xs: "48px", sm: "52px", md: "55px" },
//                         fontFamily: "var(--font-outfit)",
//                         fontSize: { xs: "0.875rem", sm: "0.95rem", lg: "1rem" },
//                         fontWeight: "500",
//                         borderRadius: "28px",
//                         boxShadow: "none",
//                         transition: "all 0.3s ease-in-out",
//                         bgcolor: "#000",
//                         color: "#FFFFFF",
//                         "&:hover": {
//                           bgcolor: "#6D50E0",
//                           color: "#fff",
//                           transform: "scale(1.05)",
//                         },
//                       }}
//                     >
//                       {t("getgeekHiringCircular.cta")}
//                     </Button>
//                   </NextLink>
//                 </Stack>
//               </Box>
//             </Box>

//             {/* Right Content - Charts */}
//             <Box
//               id="charts-container"
//               sx={{
//                 display: "flex",
//                 flexDirection: "column",
//                 flexWrap: "nowrap",
//                 gap: { xs: 3, sm: 3, md: 4 },
//                 alignItems: "center",
//                 justifyContent: {
//                   xs: "center",
//                   sm: "center",
//                   md: "flex-start",
//                 },
//                 width: { xs: "100%", md: "auto" },
//                 mt: { xs: 0, md: 0, lg: "0", xl: "7%" },
//                 mr: isArabic ? 0 : { xs: 0, md: 0, lg: "8%" },
//                 ml: isArabic ? { xs: 0, md: 0, lg: "8%" } : 0,
//               }}
//             >
//               {metrics.map((metric, index) => (
//                 <Box
//                   key={index}
//                   onMouseEnter={() => setHoveredIndex(index)}
//                   onMouseLeave={() => setHoveredIndex(null)}
//                   sx={{
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     opacity: hasAnimated ? 1 : 0,
//                     transform: hasAnimated
//                       ? "translateX(0)"
//                       : `translateX(${isArabic ? "-50px" : "50px"})`,
//                     transition: `all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) ${index * 0.2}s`,
//                     width: { xs: "100%", md: "auto" },
//                     maxWidth: { xs: "320px", sm: "350px" },
//                     cursor: "pointer",
//                     animation:
//                       hasAnimated && hoveredIndex !== index
//                         ? `heartbeat 2.5s ease-in-out infinite`
//                         : "none",
//                     "@keyframes heartbeat": {
//                       "0%, 100%": { transform: "scale(1)" },
//                       "50%": { transform: "scale(1.03)" },
//                     },
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       width: {
//                         xs: Math.min(metric.size * 0.5, 160),
//                         sm: Math.min(metric.size * 0.6, 180),
//                         md: Math.min(metric.size * 0.7, 220),
//                         lg: metric.size,
//                       },
//                       height: {
//                         xs: Math.min(metric.size * 0.5, 160),
//                         sm: Math.min(metric.size * 0.6, 180),
//                         md: Math.min(metric.size * 0.7, 220),
//                         lg: metric.size,
//                       },
//                       position: "relative",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       transform:
//                         hoveredIndex === index ? "scale(1.05)" : "scale(1)",
//                       transition: "transform 0.3s ease",
//                       filter:
//                         hoveredIndex === index
//                           ? "drop-shadow(0 8px 24px rgba(119, 92, 229, 0.3))"
//                           : "drop-shadow(0 4px 12px rgba(119, 92, 229, 0.1))",
//                     }}
//                   >
//                     <Chart
//                       options={circularChartOptions(
//                         animatedValues[index],
//                         metric.color,
//                         hoveredIndex === index,
//                       )}
//                       series={[animatedValues[index]]}
//                       type="radialBar"
//                       height="100%"
//                       width="100%"
//                     />
//                     <Box
//                       sx={{
//                         position: "absolute",
//                         top: "50%",
//                         left: "50%",
//                         transform: "translate(-50%, -50%)",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Typography
//                         sx={{
//                           fontSize: metric.numberFontSize,
//                           fontWeight: "600",
//                           color: "#775CE5",
//                           lineHeight: 1,
//                           mb: 0.5,
//                           fontFamily: "var(--font-outfit)",
//                           ml: "2%",
//                           transform:
//                             hoveredIndex === index ? "scale(1.1)" : "scale(1)",
//                           transition: "transform 0.3s ease",
//                           animation:
//                             hasAnimated && hoveredIndex !== index
//                               ? `numberBeat 2s ease-in-out infinite`
//                               : "none",
//                           "@keyframes numberBeat": {
//                             "0%, 100%": { transform: "scale(1)" },
//                             "50%": { transform: "scale(1.08)" },
//                           },
//                         }}
//                       >
//                         {metric.showPercentage
//                           ? `${metric.displayPercentage}%`
//                           : metric.displayValue}
//                       </Typography>
//                     </Box>
//                   </Box>
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       color: "#02061799",
//                       fontWeight: 500,
//                       textAlign: "center",
//                       fontSize: {
//                         xs: "0.7rem",
//                         sm: "0.75rem",
//                         md: "0.8rem",
//                         lg: "0.885rem",
//                       },
//                       fontFamily: "var(--font-outfit)",
//                       mt: { xs: 1, md: "-3%" },
//                       opacity: hoveredIndex === index ? 1 : 0.8,
//                       transition: "opacity 0.3s ease",
//                     }}
//                   >
//                     {metric.label}
//                   </Typography>
//                 </Box>
//               ))}
//             </Box>
//           </Box>
//         </Box>
//       </Container>
//     </Box>
//   );
// };

// export default GetgeekHiringCircular;
"use client";
import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Chip,
  Stack,
  Button,
} from "@mui/material";
import dynamic from "next/dynamic";
import { useRouter } from "next/navigation";
import { useTranslation } from "react-i18next";
const Chart = dynamic(() => import("react-apexcharts"), { ssr: false });
import NextLink from "next/link";
const GetgeekHiringCircular = () => {
  const router = useRouter();
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const [animatedValues, setAnimatedValues] = useState([0, 0]);
  const [hasAnimated, setHasAnimated] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const easeOutQuart = (t) => 1 - Math.pow(1 - t, 4);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            setHasAnimated(true);
            [94, 90].forEach((target, index) => {
              const duration = 2000;
              const startTime = Date.now();
              const animate = () => {
                const elapsed = Date.now() - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const easedProgress = easeOutQuart(progress);
                const current = easedProgress * target;
                setAnimatedValues((prev) => {
                  const newValues = [...prev];
                  newValues[index] = Math.round(current);
                  return newValues;
                });
                if (progress < 1) requestAnimationFrame(animate);
              };
              setTimeout(() => animate(), index * 200);
            });
          }
        });
      },
      { threshold: 0.3 },
    );
    const element = document.getElementById("charts-container");
    if (element) observer.observe(element);
    return () => {
      if (element) observer.unobserve(element);
    };
  }, [hasAnimated]);

  const circularChartOptions = (percentage, color, isHovered) => ({
    chart: {
      type: "radialBar",
      sparkline: { enabled: true },
      animations: {
        enabled: true,
        easing: "easeinout",
        speed: 1500,
        animateGradually: { enabled: true, delay: 150 },
        dynamicAnimation: { enabled: true, speed: 350 },
      },
    },
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 225,
        hollow: { size: "65%" },
        track: {
          background: "#f0ebf8",
          strokeWidth: "100%",
          opacity: isHovered ? 0.8 : 1,
        },
        dataLabels: { name: { show: false }, value: { show: false } },
      },
    },
    fill: { colors: [color] },
    stroke: { lineCap: "round" },
  });

  const metrics = [
    {
      percentage: 94,
      displayPercentage: 94,
      color: "#775CE5",
      label: t("getgeekHiringCircular.metrics.metric1"),
      size: 320,
      showPercentage: true,
      numberFontSize: {
        xs: "28px",
        sm: "32px",
        md: "40px",
        lg: "50px",
        xl: "60px",
      },
    },
    {
      percentage: 90,
      displayValue: "1M+",
      color: "#775CE5",
      label: t("getgeekHiringCircular.metrics.metric2"),
      size: 270,
      showPercentage: false,
      numberFontSize: {
        xs: "26px",
        sm: "30px",
        md: "36px",
        lg: "36px",
        xl: "44px",
      },
    },
  ];

  return (
    <Box
      sx={{
        py: { xs: 4, sm: 6, md: 8 },
        mt: { xs: 2, sm: 2, md: "-7%" },
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            bgcolor: "#FAF6FC",
            borderRadius: 4,
            p: { xs: 3, sm: 4, md: 6, lg: 8 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 4, sm: 5, md: 6 },
              alignItems: "flex-start",
            }}
          >
            {/* Left Content */}
            <Box sx={{ flex: 1, width: "100%" }}>
              <Chip
                label={t("getgeekHiringCircular.chip")}
                sx={{
                  backgroundColor: "transparent",
                  border: "1px solid #0206174D",
                  mb: 2,
                  color: "#818E98",
                  fontSize: { xs: "12px", sm: "14px", md: "16px", lg: "17px" },
                  fontWeight: "500",
                  textTransform: "capitalize",
                  px: 0.7,
                  py: { xs: 1.2, sm: 1.5, md: 2, lg: 2.3 },
                  fontFamily: "var(--font-outfit)",
                  borderRadius: "40px",
                }}
              />

              <Typography
                variant="h3"
                sx={{
                  fontWeight: 600,
                  mb: 2.8,
                  fontSize: {
                    xs: "1.5rem",
                    sm: "1.75rem",
                    md: "2rem",
                    lg: "2rem",
                    xl: "2.5rem",
                  },
                  lineHeight: 1.3,
                  fontFamily: "var(--font-plusjakarta)",
                  color: "#020617",
                  maxWidth: { xs: "100%", lg: "610px" },
                  textAlign: isArabic ? "right" : "left",
                }}
              >
                {t("getgeekHiringCircular.title1")}
                <span style={{ color: "#775CE5" }}>
                  {t("getgeekHiringCircular.titleHighlight1")}
                  {/* <br /> */}
                </span>
                {t("getgeekHiringCircular.title2")}
                <span style={{ color: "#775CE5" }}>
                  {t("getgeekHiringCircular.titleHighlight2")}
                </span>
              </Typography>

              {/* <Typography
                sx={{
                  color: "#020617",
                  mb: 2.5,
                  lineHeight: 1.4,
                  fontFamily: "var(--font-outfit)",
                  fontSize: {
                    xs: "16px",
                    sm: "16px",
                    md: "16px",
                    lg: "16px",
                    xl: "20px",
                  },
                  maxWidth: { xs: "100%", lg: 500 },
                  textAlign: isArabic ? "right" : "left",
                }}
              >
                {t("getgeekHiringCircular.stat1")}
              </Typography> */}

              <Typography
                variant="body1"
                sx={{
                  color: "#02061799",
                  mb: 2.5,
                  lineHeight: 1.3,
                  fontFamily: "var(--font-outfit)",
                  fontSize: {
                    xs: "15px",
                    sm: "16px",
                    md: "17px",
                    lg: "17px",
                    xl: "19px",
                  },
                  maxWidth: { xs: "100%", lg: "550px" },
                  fontWeight: 400,
                  textAlign: isArabic ? "right" : "left",
                }}
              >
                {t("getgeekHiringCircular.para1")}
              </Typography>

              {/* <Typography
                variant="body1"
                sx={{
                  color: "#02061799",
                  mb: { xs: 2.5, md: 5 },
                  lineHeight: 1.3,
                  maxWidth: { xs: "100%", lg: "550px" },
                  fontWeight: 400,
                  fontSize: {
                    xs: "15px",
                    sm: "16px",
                    md: "17px",
                    lg: "17px",
                    xl: "19px",
                  },
                  fontFamily: "var(--font-outfit)",
                  textAlign: isArabic ? "right" : "left",
                }}
              >
                {t("getgeekHiringCircular.para2")}
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: "#02061799",
                  mb: { xs: 3, md: 5 },
                  lineHeight: 1.3,
                  maxWidth: { xs: "100%", lg: "550px" },
                  fontWeight: 400,
                  fontSize: {
                    xs: "15px",
                    sm: "16px",
                    md: "17px",
                    lg: "17px",
                    xl: "19px",
                  },
                  fontFamily: "var(--font-outfit)",
                  textAlign: isArabic ? "right" : "left",
                }}
              >
                {t("getgeekHiringCircular.para3")}
              </Typography> */}

              {/* Stats Boxes */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1.5,
                  maxWidth: { xs: "100%", lg: "550px" },
                }}
              >
                {[
                  {
                    val: t("getgeekHiringCircular.box1Value"),
                    label: t("getgeekHiringCircular.box1Label"),
                  },
                  {
                    val: t("getgeekHiringCircular.box2Value"),
                    label: t("getgeekHiringCircular.box2Label"),
                  },
                  {
                    val: t("getgeekHiringCircular.box3Value"),
                    label: t("getgeekHiringCircular.box3Label"),
                  },
                ].map((box, i) => (
                  <Paper
                    key={i}
                    elevation={0}
                    sx={{
                      bgcolor: "#E8D9FF",
                      p: { xs: 1.5, sm: 2 },
                      borderRadius: 3,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: isArabic
                          ? "translateX(-8px)"
                          : "translateX(8px)",
                        boxShadow: "0 4px 20px rgba(119, 92, 229, 0.15)",
                      },
                    }}
                  >
                    <Typography
                      variant="h4"
                      component="div"
                      sx={{
                        color: "#9048FB",
                        fontWeight: 700,
                        mb: 0.5,
                        ml: "2%",
                        fontFamily: "var(--font-outfit)",
                        fontSize: { xs: "1.75rem", sm: "2rem", md: "2.125rem" },
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "10px",
                      }}
                    >
                      {box.val.includes("→")
                        ? box.val.split("→").map((part, idx, arr) => (
                            <React.Fragment key={idx}>
                              {part.trim()}
                              {idx < arr.length - 1 && (
                                <svg
                                  width="28"
                                  height="18"
                                  viewBox="0 0 28 18"
                                  fill="none"
                                  style={{
                                    display: "inline-block",
                                    transform: isArabic
                                      ? "scaleX(-1)"
                                      : "none",
                                  }}
                                >
                                  <path
                                    d="M1 9H26M26 9L19 2M26 9L19 16"
                                    stroke="#9048FB"
                                    strokeWidth="3.2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              )}
                            </React.Fragment>
                          ))
                        : box.val}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#02061799",
                        fontFamily: "var(--font-outfit)",
                        ml: "2%",
                        fontWeight: 400,
                        fontSize: { xs: "14px", sm: "15px", md: "16px" },
                      }}
                    >
                      {box.label}
                    </Typography>
                  </Paper>
                ))}

                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={{ xs: 1.5, sm: 2 }}
                  alignItems={{ xs: "stretch", sm: "center" }}
                  sx={{ mt: "2%" }}
                >
                  <NextLink href="/free-trial-of-ai-recruiting-tool" passHref legacyBehavior>
                    <Button
                      component="a"
                      sx={{
                        textTransform: "none",
                        px: { xs: 2.5, sm: 3, md: 2.8 },
                        py: { xs: 1.5, sm: 1.6, md: 1.5 },
                        height: { xs: "48px", sm: "52px", md: "55px" },
                        fontFamily: "var(--font-outfit)",
                        fontSize: { xs: "0.875rem", sm: "0.95rem", lg: "1rem" },
                        fontWeight: "500",
                        borderRadius: "28px",
                        boxShadow: "none",
                        transition: "all 0.3s ease-in-out",
                        bgcolor: "#000",
                        color: "#FFFFFF",
                        "&:hover": {
                          bgcolor: "#6D50E0",
                          color: "#fff",
                          transform: "scale(1.05)",
                        },
                      }}
                    >
                      {t("getgeekHiringCircular.cta")}
                    </Button>
                  </NextLink>
                </Stack>
              </Box>
            </Box>

            {/* Right Content - Charts */}
            <Box
              id="charts-container"
              sx={{
                display: "flex",
                flexDirection: "column",
                flexWrap: "nowrap",
                gap: { xs: 3, sm: 3, md: 4 },
                alignItems: "center",
                justifyContent: {
                  xs: "center",
                  sm: "center",
                  md: "flex-start",
                },
                width: { xs: "100%", md: "auto" },
                mt: { xs: 0, md: 0, lg: "0", xl: "7%" },
                mr: isArabic ? 0 : { xs: 0, md: 0, lg: "8%" },
                ml: isArabic ? { xs: 0, md: 0, lg: "8%" } : 0,
              }}
            >
              {metrics.map((metric, index) => (
                <Box
                  key={index}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    opacity: hasAnimated ? 1 : 0,
                    transform: hasAnimated
                      ? "translateX(0)"
                      : `translateX(${isArabic ? "-50px" : "50px"})`,
                    transition: `all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) ${index * 0.2}s`,
                    width: { xs: "100%", md: "auto" },
                    maxWidth: { xs: "320px", sm: "350px" },
                    cursor: "pointer",
                    animation:
                      hasAnimated && hoveredIndex !== index
                        ? `heartbeat 2.5s ease-in-out infinite`
                        : "none",
                    "@keyframes heartbeat": {
                      "0%, 100%": { transform: "scale(1)" },
                      "50%": { transform: "scale(1.03)" },
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: {
                        xs: Math.min(metric.size * 0.5, 160),
                        sm: Math.min(metric.size * 0.6, 180),
                        md: Math.min(metric.size * 0.7, 220),
                        lg: metric.size,
                      },
                      height: {
                        xs: Math.min(metric.size * 0.5, 160),
                        sm: Math.min(metric.size * 0.6, 180),
                        md: Math.min(metric.size * 0.7, 220),
                        lg: metric.size,
                      },
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transform:
                        hoveredIndex === index ? "scale(1.05)" : "scale(1)",
                      transition: "transform 0.3s ease",
                      filter:
                        hoveredIndex === index
                          ? "drop-shadow(0 8px 24px rgba(119, 92, 229, 0.3))"
                          : "drop-shadow(0 4px 12px rgba(119, 92, 229, 0.1))",
                    }}
                  >
                    <Chart
                      options={circularChartOptions(
                        animatedValues[index],
                        metric.color,
                        hoveredIndex === index,
                      )}
                      series={[animatedValues[index]]}
                      type="radialBar"
                      height="100%"
                      width="100%"
                    />
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: metric.numberFontSize,
                          fontWeight: "600",
                          color: "#775CE5",
                          lineHeight: 1,
                          mb: 0.5,
                          fontFamily: "var(--font-outfit)",
                          ml: "2%",
                          transform:
                            hoveredIndex === index ? "scale(1.1)" : "scale(1)",
                          transition: "transform 0.3s ease",
                          animation:
                            hasAnimated && hoveredIndex !== index
                              ? `numberBeat 2s ease-in-out infinite`
                              : "none",
                          "@keyframes numberBeat": {
                            "0%, 100%": { transform: "scale(1)" },
                            "50%": { transform: "scale(1.08)" },
                          },
                        }}
                      >
                        {metric.showPercentage
                          ? `${metric.displayPercentage}%`
                          : metric.displayValue}
                      </Typography>
                    </Box>
                  </Box>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#02061799",
                      fontWeight: 500,
                      textAlign: "center",
                      fontSize: {
                        xs: "0.7rem",
                        sm: "0.75rem",
                        md: "0.8rem",
                        lg: "0.885rem",
                      },
                      fontFamily: "var(--font-outfit)",
                      mt: { xs: 1, md: "-3%" },
                      opacity: hoveredIndex === index ? 1 : 0.8,
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    {metric.label}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default GetgeekHiringCircular;